import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Link, useLocation, useParams } from 'react-router-dom'

import { useSelector } from 'react-redux'

function NavbarEmpInfo() {
  const locaiton = useLocation()
  const pathname = locaiton.pathname
  const { id } = useParams()

  const menuSubList = useSelector((state) => state.allMenuReducer.allMenu)

  const [newMenu, setNewMenu] = useState([])

  useEffect(() => {
    if (menuSubList?.allMenu) {
      const menuMain = menuSubList.allMenu.find((item) => item.id === 11) //id emp

      if (menuMain) {
        const subMenu = menuMain.submenu.find((item) => item.menuId === 5) //id cln

        if (subMenu?.menuSubList.length > 0) {
          const subMenuList = subMenu.menuSubList.find(
            (item) => item.menuId === 7
          ) //id Employee Info

          setNewMenu(subMenuList?.menuSubList)
        }
      }
    }
  }, [menuSubList])

  const getLinkQuery = (url) => {
    // return `${url}${locaiton.search}`
    return `${url}/${id}`
  }

  const menu = newMenu.map((m, i) => {
    return {
      id: uuidv4(),
      name: m?.label,
      link: getLinkQuery(m?.link)
    }
  })

  const chkIsSubMenu = (d) => {
    // let path = getLinkQuery(pathname)
    let path = pathname
    return path === d.link
  }
  return (
    <div
      className="d-flex p-3 "
      style={{ backgroundColor: '#EFEFEF', maxHeight: '53px' }}
    >
      {menu.map((m, i) => (
        <Link
          to={m.link}
          key={i}
          style={{ whiteSpace: 'nowrap' }}
          className={`me-3  font-small-2 text-reset text-decoration-none ${
            chkIsSubMenu(m) ? '' : 'opacity-25'
          }`}
        >
          {m.name}
        </Link>
      ))}
    </div>
  )
}

export default NavbarEmpInfo
